var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      !_vm.currentKnowledgeBaseId
        ? _c("div", [
            _c("div", { staticClass: "header-section" }, [
              _c("div", { staticClass: "title-wrapper" }, [
                _c("h1", { staticClass: "main-title" }, [
                  _vm._v(_vm._s(_vm.$t("voiceagent.knowledgeBase"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "title-description" }, [
                  _vm._v(_vm._s(_vm.$t("voiceagent.knowledgeBaseDescription"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "table-wrapper" },
                [
                  _c("div", { staticClass: "toolbar" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("a-input-search", {
                          staticClass: "search-input",
                          staticStyle: {
                            width: "300px",
                            margin: "unset !important",
                          },
                          attrs: { placeholder: "Ara" },
                          on: { input: _vm.onSearch },
                          model: {
                            value: _vm.searchText,
                            callback: function ($$v) {
                              _vm.searchText = $$v
                            },
                            expression: "searchText",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "PermissionController",
                          { attrs: { permissions: ["voice-agent.create"] } },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: { primary: "" },
                                on: { click: _vm.createKnowledgeBase },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("add"),
                                ]),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t("voiceagent.newKnowledgeBase")
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-spin",
                    { attrs: { spinning: _vm.loading } },
                    [
                      _c("SupsisTable", {
                        attrs: {
                          columns: _vm.getCols(),
                          rows: _vm.paginatedKnowledgeBases,
                          "top-pagination": true,
                          "empty-data-bordered": "",
                          "bottom-pagination": false,
                          "pagination-cursor": _vm.pagination,
                          options: {
                            rowStyleOption: _vm.rowStyleOption,
                            clipboardOption: _vm.clipboardOption,
                            fixedHeader: true,
                            id: "knowledge-bases-table",
                            borderX: true,
                            borderY: true,
                          },
                        },
                        on: {
                          "cursor-changed": function (cursor) {
                            return (_vm.pagination = cursor)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _c("KnowledgeBaseDetail", {
            attrs: {
              channelId: _vm.channelId,
              knowledgeBaseId: _vm.currentKnowledgeBaseId,
            },
            on: { back: _vm.goBackToList },
          }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("voiceagent.createNewKnowledgeBase"),
            footer: null,
            width: "600px",
          },
          on: {
            cancel: function ($event) {
              _vm.showCreateModal = false
            },
          },
          model: {
            value: _vm.showCreateModal,
            callback: function ($$v) {
              _vm.showCreateModal = $$v
            },
            expression: "showCreateModal",
          },
        },
        [
          _c(
            "a-form",
            {
              attrs: { form: _vm.form, layout: "vertical" },
              on: { submit: _vm.handleCreateSubmit },
            },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.knowledgeBaseName") } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "knowledge_base_name",
                          {
                            rules: [
                              {
                                required: true,
                                message: "Lütfen bilgi tabanı adı girin!",
                              },
                            ],
                          },
                        ],
                        expression:
                          "[\n                        'knowledge_base_name',\n                        {\n                            rules: [{ required: true, message: 'Lütfen bilgi tabanı adı girin!' }]\n                        }\n                    ]",
                      },
                    ],
                    attrs: { placeholder: "Bilgi Tabanı Adı" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.urlsPerLine") } },
                [
                  _c("a-textarea", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["knowledge_base_urls"],
                        expression: "['knowledge_base_urls']",
                      },
                    ],
                    attrs: { placeholder: "https://www.example.com", rows: 4 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.uploadFile") } },
                [
                  _c(
                    "a-upload-dragger",
                    {
                      attrs: {
                        name: "files",
                        multiple: true,
                        fileList: _vm.createFileList,
                        beforeUpload: _vm.beforeUpload,
                      },
                      on: { change: _vm.handleCreateFileChange },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "ant-upload-drag-icon" },
                        [_c("a-icon", { attrs: { type: "inbox" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "ant-upload-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("voiceagent.dragDropOrClickToSelect"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ant-upload-hint" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("voiceagent.supportedFileTypes")) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                [
                  _c(
                    "a-checkbox",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "enable_auto_refresh",
                            { valuePropName: "checked" },
                          ],
                          expression:
                            "['enable_auto_refresh', { valuePropName: 'checked' }]",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.autoRefreshEvery12Hours")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.addText") } },
                [
                  _vm._l(_vm.texts, function (text, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "text-item" },
                      [
                        _c(
                          "a-row",
                          { attrs: { gutter: 16 } },
                          [
                            _c(
                              "a-col",
                              { attrs: { span: 8 } },
                              [
                                _c("a-input", {
                                  staticClass: "mb-2",
                                  attrs: { placeholder: "Başlık" },
                                  model: {
                                    value: text.title,
                                    callback: function ($$v) {
                                      _vm.$set(text, "title", $$v)
                                    },
                                    expression: "text.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-col",
                              { attrs: { span: 14 } },
                              [
                                _c("a-textarea", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    placeholder: "Metin İçeriği",
                                    rows: 2,
                                  },
                                  model: {
                                    value: text.text,
                                    callback: function ($$v) {
                                      _vm.$set(text, "text", $$v)
                                    },
                                    expression: "text.text",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-col",
                              { attrs: { span: 2 } },
                              [
                                _c("a-button", {
                                  attrs: {
                                    shape: "circle",
                                    type: "danger",
                                    icon: "delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeText(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "dashed", block: "" },
                      on: { click: _vm.addText },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: {
                            "font-size": "18px",
                            "vertical-align": "middle",
                          },
                        },
                        [_vm._v("add")]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.addText")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function ($event) {
                          _vm.showCreateModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.cancel")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        "html-type": "submit",
                        loading: _vm.submitting,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.create")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }